import styled from "styled-components";

const FlexItem = styled.div`
	flex: 1;
`;

export { FlexItem };
